<template>
  <v-dialog
    scrollable
    v-model="active"
    lazy
    max-width="98vw">
    <nx-entity-version-navigator :active="active"
                                 :entity="entity"
                                 :entity-id="draft.entityId"
                                 :entity-version-id="draft.versionId"
                                 :entity-relative-version-id="draft.relativeVersionId"
                                 @close="close"/>
  </v-dialog>
</template>

<script>
import StorableEditorComponent from '@/mixins/storable-editor-component';
import NxEntityVersionNavigator from '@/modules/entity/editor/version/EntityVersionNavigator';

export default {
  name: 'nx-entity-version-navigate-action',
  mixins: [StorableEditorComponent],
  components: {
    NxEntityVersionNavigator,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    draft() {
      return this.state.draft;
    },
  },
  methods: {
    close() {
      this.active = false;
      this.$emit('close');
    },
  },
  mounted() {
    this.active = true;
  },
};
</script>
